import useSWR from 'swr'
import { useLidoSDK } from './useLidoSDK'
import { formatEther, parseEther } from 'viem'
import { formatFormAmount } from '~/utils/numbers'

export const useWstEth2StEthRate = (amount: string) => {
  const { wrap } = useLidoSDK()
  const formattedAmount = parseEther(amount)
  const { data, isValidating } = useSWR(
    ['lido-wsteth-2-steth-rate', formattedAmount.toString()],
    async () => {
      if (formattedAmount === 0n) {
        return 0n
      }
      return wrap.convertWstethToSteth(formattedAmount)
    },
    {
      refreshInterval: 60000,
    },
  )

  return {
    rate: !!data ? formatFormAmount(formatEther(data), 6) : '0',
    isValidating,
  }
}
